import LZString from "lz-string"

export async function makeRequest(method, url, headers, file, callback) {
  return await new Promise(function (resolve, reject) {
    const filecontent = file.content
    const compressedString = LZString.compressToBase64(filecontent)

    const formData = new FormData()

    formData.append("name", file.value.name)
    formData.append("file", compressedString)

    headers.forEach(header => {
      formData.append(header.key, header.value)
    })

    let xhr = new XMLHttpRequest()

    if ("withCredentials" in xhr) {
      // Most browsers.
      xhr.open(method, url, true)
    } else if (typeof XDomainRequest !== "undefined") {
      // // IE8 & IE9
      // xhr = new XDomainRequest()
      // xhr.open(method, url)
    } else {
      // CORS not supported.
      xhr = null
    }

    xhr.onload = function () {
      if (this.status >= 200 && this.status < 300) {
        file.responseText = xhr.response
        if (callback) {
          callback(file)
        }
      } else {
        reject({
          status: this.status,
          statusText: xhr.statusText
        })
      }
    }
    xhr.onerror = function () {
      reject({
        status: this.status,
        statusText: xhr.statusText
      })
    }

    xhr.withCredentials = false
    xhr.send(formData)
  })
}
